export const MATERIAL_PRICE = 6.5;
